import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountDownTimerComponent } from './count-down-timer.component';
// import { SvgModule } from '../svg/svg.module';
import { TranslationModule } from 'src/app/i18n/translation.module';

@NgModule({
  declarations: [CountDownTimerComponent],
  imports: [
    CommonModule,
    // SvgModule,
    TranslationModule
  ],
  exports: [CountDownTimerComponent]
})
export class CountDownTimerModule { }